/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Type_TeamInputs */

const en_new_project_type_team = /** @type {(inputs: New_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const fr_new_project_type_team = /** @type {(inputs: New_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipe`)
};

const de_new_project_type_team = /** @type {(inputs: New_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const it_new_project_type_team = /** @type {(inputs: New_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squadra`)
};

const ru_new_project_type_team = /** @type {(inputs: New_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команда`)
};

const es_new_project_type_team = /** @type {(inputs: New_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipo`)
};

const zh_cn2_new_project_type_team = /** @type {(inputs: New_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`团队`)
};

const ja_new_project_type_team = /** @type {(inputs: New_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チーム`)
};

const hi_new_project_type_team = /** @type {(inputs: New_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम`)
};

const pt_pt2_new_project_type_team = /** @type {(inputs: New_Project_Type_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipe`)
};

/**
* | output |
* | --- |
* | "Team" |
*
* @param {New_Project_Type_TeamInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_type_team = /** @type {((inputs?: New_Project_Type_TeamInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Type_TeamInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_type_team(inputs)
	if (locale === "de") return de_new_project_type_team(inputs)
	if (locale === "it") return it_new_project_type_team(inputs)
	if (locale === "ru") return ru_new_project_type_team(inputs)
	if (locale === "es") return es_new_project_type_team(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_type_team(inputs)
	if (locale === "ja") return ja_new_project_type_team(inputs)
	if (locale === "hi") return hi_new_project_type_team(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_type_team(inputs)
	return en_new_project_type_team(inputs)
});